import { render, staticRenderFns } from "./page.vue?vue&type=template&id=033c55b5&"
import script from "./page.vue?vue&type=script&lang=js&"
export * from "./page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {XcBanner: require('/Users/jerei/Documents/宇浩/工作/nuxt2-demo/components/XcBanner.vue').default,XcCrumbs: require('/Users/jerei/Documents/宇浩/工作/nuxt2-demo/components/XcCrumbs.vue').default,JrSection: require('/Users/jerei/Documents/宇浩/工作/nuxt2-demo/components/jr/Section.vue').default,JrPage: require('/Users/jerei/Documents/宇浩/工作/nuxt2-demo/components/jr/Page.vue').default})
